import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function NearbyMidCTA() {
  return (
    <section
      aria-labelledby="nearby-mid-cta-heading"
      className="relative isolate overflow-hidden bg-primary text-primary-foreground"
    >
      <div className="overlay-forest absolute inset-0 -z-10" />

      <div className="shell py-16 md:py-18">
        <Reveal>
          <Eyebrow tone="light">Your Adventure Needs a Base Camp</Eyebrow>
        </Reveal>
        <h2 id="nearby-mid-cta-heading" className="display-lg mt-6 max-w-[12ch]">
          <MaskReveal>Start With Your Stay</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg">
            Choose your dates, find the right RV site and make Auburn RV Resort the starting point
            for your Northern California adventure.
          </p>
        </Reveal>
        <Reveal delay={0.16}>
          <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
              Check Availability
            </ResortLink>
            <ResortLink variant="onDark" href="/accommodations/" className="w-full sm:w-auto">
              View RV Sites
            </ResortLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
